import { axios } from "../axios";
import { GET } from "../endpoints";

export const getSettingProfile = async (data) => {
  try {
    let response = await axios.get(GET.GET_PROFILE, {
      params: data,
    });
    return response;
  } catch (err) {
    throw err;
  }
};
